// components/Contact.js
import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="section contact-section">
      <div className="container">
        <div className="section-title">
          <h2>Get In Touch</h2>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Let's Connect</h3>
            <p>Interested in bringing Nozomi Robotics to your classroom? Have questions about the kit or the software? Want to collaborate on computational thinking research?</p>

            <div className="contact-links">
              <a href="mailto:hello@nozomirobotics.com" className="contact-link">📧</a>
              <a href="https://www.instagram.com/nozomirobotics/" className="contact-link">📸</a>
              <a href="https://www.linkedin.com/company/nozomi-robotics/" target="_blank" rel="noopener noreferrer" className="contact-link">🔗</a>
              {/* <a href="tel:+1234567890" className="contact-link">📱</a> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;